import { render, staticRenderFns } from "./DocTree.vue?vue&type=template&id=65d0f6be&"
import script from "./DocTree.vue?vue&type=script&lang=js&"
export * from "./DocTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports